// extracted by mini-css-extract-plugin
export default {"bigNumber":"hJxSpyPT7w62kWIGTH0O"};